/**
 * CSV export template shape (API + UI). For Media Devoted | Created By Ciro Autiero
 */

export interface CsvExportTemplate {
  id: string;
  name: string;
  color: string;
  tab: string;
  columns: string[];
  downloadBaseName?: string;
  isDefault: boolean;
}

export function pickDefaultTemplate(
  templates: CsvExportTemplate[],
  tab: string,
): CsvExportTemplate | null {
  const forTab = templates.filter((t) => t.tab === tab);
  if (forTab.length === 0) return null;
  return forTab.find((t) => t.isDefault) ?? forTab[0];
}
